module.exports = __webpack_public_path__ + "img/asx_safe.a92884ad.jpg";